const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class AncillaryCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.setTimeout(() => {
      this.carousel = this.setupCarousel()
    }, 1000)
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.35,
          spacing: 10,
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('ancillary-carousel')) {
  customElements.define('ancillary-carousel', AncillaryCarousel)
}
